import { makeVar, ReactiveVar } from '@apollo/client'
import { useActiveStoreView } from '@emico-hooks/use-active-storeview'
import { syncReactiveVar } from '@emico-utils/reactive-var-utils'
import { createContext, ReactNode, useContext, useMemo } from 'react'

const CartIdContext = createContext<ReactiveVar<string | undefined>>(
  makeVar<string | undefined>(undefined),
)

interface CartIdProviderProps {
  children: ReactNode
}

export function CartIdProvider({ children }: CartIdProviderProps) {
  const storeView = useActiveStoreView()
  const rv = useMemo(() => {
    const emptyVar = makeVar<string | undefined>(undefined)
    const rv = syncReactiveVar(emptyVar, `${storeView?.storeId}/cart-id`)

    return rv
  }, [storeView?.storeId])

  return <CartIdContext.Provider value={rv}>{children}</CartIdContext.Provider>
}

export function useCartIdContext() {
  return useContext(CartIdContext)
}
